import { render, staticRenderFns } from "./benefitList.vue?vue&type=template&id=538b83a6&scoped=true"
import script from "./benefitList.vue?vue&type=script&lang=js"
export * from "./benefitList.vue?vue&type=script&lang=js"
import style0 from "./benefitList.vue?vue&type=style&index=0&id=538b83a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b83a6",
  null
  
)

export default component.exports